module.exports = __webpack_public_path__ + "static/lens-simulation-app-79ad2841a2fcd8e795526019790e39b5.png";